export const inventory = {
  "Living Room": [
    ["Sofa (1 Seater)", "🛋️"],
    ["Sofa (2 Seater)", "🛋️"],
    ["Sofa (3 Seater)", "🛋️"],
    ["Center Table", "▱"],
    ["TV (LED/LCD)", "▣"],
    ["TV Unit", "▤"],
    ["Bookshelf", "▥"],
    ["Shoe Rack", "▥"],
    ["Armchair", "🪑"]
  ],
  Bedroom: [
    ["Single Bed", "▰"],
    ["Double Bed", "▰"],
    ["Wardrobe", "▤"],
    ["Dressing Table", "▤"],
    ["Mattress", "▱"],
    ["Bedside Table", "▤"]
  ],
  Kitchen: [
    ["Dining Table", "▱"],
    ["Dining Chair", "🪑"],
    ["Kitchen Cabinet", "▤"],
    ["Gas Stove", "▣"],
    ["Refrigerator", "▣"]
  ],
  Appliances: [
    ["Washing Machine", "▣"],
    ["Refrigerator", "▣"],
    ["Air Conditioner", "▣"],
    ["Microwave", "▣"]
  ],
  Furniture: [
    ["Office Table", "▱"],
    ["Office Chair", "🪑"],
    ["Cupboard", "▤"],
    ["Sofa", "🛋️"]
  ],
  Others: [
    ["Carton Boxes", "▣"],
    ["Bicycle", "🚲"],
    ["Other Item", "▦"]
  ]
};

export const services = [
  ["Packing Service", "Professional packing with high-quality materials.", 3000, "📦"],
  ["Furniture Dismantling & Reassembly", "Safe dismantling and reassembly at your new location.", 1500, "🪑"],
  ["Packing Materials", "Boxes, bubble wrap, tape and other materials.", 1000, "📦"],
  ["Storage & Warehousing", "Short & long term secure storage facilities.", 5000, "🏬"],
  ["Pet Relocation", "Safe and comfortable relocation for your pets.", 4000, "🐕"],
  ["Plant Relocation", "Special care for your valuable plants.", 1500, "🪴"],
  ["Vehicle Transportation", "Safe and secure car & bike transportation.", 8000, "🚚"],
  ["International Relocation", "Global moving solutions with end-to-end support.", 25000, "✈️"],
  ["Moving Insurance", "Comprehensive insurance for complete peace of mind.", 1000, "🛡️"],
  ["Home Cleaning", "Professional cleaning before or after move.", 2000, "🧹"]
];

export const steps = [
  "Move Information",
  "Items & Inventory",
  "Pickup & Delivery",
  "Additional Services",
  "Your Details",
  "Get Quote"
];
